export const isLoggedIn = state => (state.userDetails.user);
